import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Filtros } from '../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '../../../shared/crud/ListaBase';
import { ListitemBuilder } from '../../../shared/dropdown-list/ListItemBuilder';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { Parametro } from '../../../shared/service-base/parametro';
import { RelatorioVeiculoDetalhadoService } from './service/relatorio-veiculo-detalhado.service';

declare var $: any;

@Component({
  selector: 'app-relatorio-veiculo-detalhado',
  templateUrl: './relatorio-veiculo-detalhado.component.html',
  styleUrls: ['./relatorio-veiculo-detalhado.component.css']
})
export class RelatorioVeiculoDetalhadoComponent extends ListaBase implements OnInit {
  periodo;
  filtros: any = {};
  meses: string[] = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
  ]

  dadosMensal = {};
  anoFiltro: any;
  ano: any;
  mes_inicial: any;
  mes_final: any;
  anoAtual = new Date();
  anoAnterior = new Date();
  anoRetrasado = new Date();
  parametrosFiltro: any;
  carregando = false;

  constructor(service: RelatorioVeiculoDetalhadoService, toast: ToastrService, router: Router, private route: ActivatedRoute, private exportExcel: ExportExcelService) {
    super(service, toast, router);
    this.nomeModulo = 'relatorio-veiculo-detalhado'
    this.route.queryParams.subscribe(params => {
      this.setaValorData(params['ano'], params['mes_inicial'], params['mes_final']);
      this.carregarFiltrosParametros();
    });
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  ngOnInit() {
    this.anoFiltro = this.filtros.ano;
    this.carregarAno();
    this.carregarMesInicial();
    this.carregarMesFinal();
    this.buscar();
  }

  setaValorData(ano: any, mes_inicial: any, mes_final: any) {
    if (ano === undefined || ano === null) {
      this.ano = this.anoAtual.getFullYear();
    }

    if (mes_inicial === undefined || mes_inicial === null) {
      this.mes_inicial = 1;
    }

    if (mes_final === undefined || mes_final === null) {
      this.mes_final = 12;
    }
    this.filtros = { ano: this.ano, mes_inicial: this.mes_inicial, mes_final: this.mes_final };
  }

  buscar() {
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.carregando = true;

    this.service.buscar(objFiltro)
      .then(res => {

        this.dadosMensal = res;

        this.carregando = false;
      });
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.dealer
      || this.filtros.ano
      || this.filtros.mes_inicial
      || this.filtros.mes_final;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  private carregarAno() {
    this.ano =
      new ListitemBuilder()
        .add(1, this.anoRetrasado.getFullYear() - 2)
        .add(2, this.anoAnterior.getFullYear() - 1)
        .add(3, this.anoAtual.getFullYear())
        .build();
  }

  private carregarMesInicial() {
    this.mes_inicial =
      new ListitemBuilder()
        .add(1, 1)
        .add(2, 2)
        .add(3, 3)
        .add(4, 4)
        .add(5, 5)
        .add(6, 6)
        .add(7, 7)
        .add(8, 8)
        .add(9, 9)
        .add(10, 10)
        .add(11, 11)
        .add(12, 12)
        .build();
  }

  private carregarMesFinal() {
    this.mes_final =
      new ListitemBuilder()
        .add(1, 1)
        .add(2, 2)
        .add(3, 3)
        .add(4, 4)
        .add(5, 5)
        .add(6, 6)
        .add(7, 7)
        .add(8, 8)
        .add(9, 9)
        .add(10, 10)
        .add(11, 11)
        .add(12, 12)
        .build();
  }

  public definirFiltragem() {
    $('#relatorio-veiculo-detalhado-filtro').modal();
  }

  voltar() {
    this.router.navigateByUrl(this.obterUrlComFiltros());
  }

  obterUrlComFiltros(): string {
    let url = '';
    return 'veiculo/vendido' + url;
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }
}
